import Link from '@atlaskit/link';
import * as React from 'react';
export default {
  Link,
  React
};